import { render, staticRenderFns } from "./NFTLogoRenderer.vue?vue&type=template&id=7130f22e&scoped=true&"
import script from "./NFTLogoRenderer.vue?vue&type=script&lang=ts&"
export * from "./NFTLogoRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./NFTLogoRenderer.vue?vue&type=style&index=0&id=7130f22e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130f22e",
  null
  
)

export default component.exports